import React from "react";
import SummaryContainer from "./SummaryContainer";
import SummaryHeader from "./SummaryHeader";
import LoadingIndicator from "./LoadingIndicator";
import "../../assets/icons/copyToclipboard.png";
import { Button, notification } from "antd";

const SummaryTextInner = ({ summary, error, emptyMessage }) => {
    return (
        <div
            style={{ userSelect: "text", position: "relative" }}
            onMouseDown={(e) => {
                e.stopPropagation();
            }}
        >
            {error ? (
                <p style={{ color: "red" }}>{error}</p>
            ) : summary ? (
                <>
                    <p style={{ margin:  '5px 0' }}>{summary}</p>
                </>
            ) : (
                <p>{emptyMessage}</p>
            )}
        </div>
    );
};


const SummaryText = ({ header, loading, summary, error }) => {
    const handleCopy = () => {
        if (summary) {
            navigator.clipboard
                .writeText(summary)
                .then(() => {
                    notification.success({
                        message: "Copied to Clipboard",
                        description: "The summary has been copied successfully!",
                        placement: "top",
                        duration: 1,
                    });
                })
                .catch((err) => {
                    console.error("Failed to copy text:", err);
                    notification.error({
                        message: "Copy Failed",
                        description: "An error occurred while copying to clipboard.",
                        placement: "top",
                        duration: 1,
                    });
                });
        }
    };
    return (

        <SummaryContainer>
            <div style={{
                display: `flex`,
                alignItems: `flex-start`,
                justifyContent: `space-between`,
            }}>
                <SummaryHeader>{header}</SummaryHeader>
                {summary && !loading && <div>
                    <Button
                        style={{
                            position: "inherit",
                            border: "none",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: "8px",
                            padding: "5px 10px",
                            backgroundColor: "transparent",
                        }}
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={handleCopy}
                        icon={
                            <img
                                src={require("../../assets/icons/copyToclipboard.png")}
                                alt="Copy"
                                style={{ width: "30px", height: "30px" }}
                            />
                        }
                    >
                    </Button>
                </div>}
            </div>

            {loading ? (
                <LoadingIndicator />
            ) : (
                <SummaryTextInner
                    summary={summary}
                    error={error}
                    emptyMessage="No summary found."
                />
            )}
        </SummaryContainer>
    );
};

export default SummaryText;
